import React from "react";
import GridListToggle from "../../../Components/Common/ViewToggle";

export default function ViewToggle({ value, onChange }) {
  return (
    <GridListToggle
      className="bills-page__toggle"
      value={value}
      onChange={onChange}
      ariaLabel="Change bills layout"
    />
  );
}
